import { useState } from 'react'

import {
  FetchBonusTypesAvailableRequest,
  FetchBonusTypesAvailableResponse,
} from '../model/bonus.model'

import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'

interface StateInterface {
  data?: FetchBonusTypesAvailableResponse
  loading: boolean
  error?: string
}

interface ComponentLifeCycle {
  unmounted: boolean
}

const InitialState = {
  loading: false,
}

export default function useFetchBonusTypesAvailable() {
  const { bonusService } = useAppDepsContext()

  const [state, setState] = useState<StateInterface>(InitialState)

  function isInitialState() {
    return state.loading === false && !state.data && !state.error
  }

  function fetchBonusesAvailable(
    FetchBonusTypesAvailableRequest: FetchBonusTypesAvailableRequest,
    componentLifeCycle: ComponentLifeCycle,
  ) {
    setState({ ...state, loading: true })

    bonusService
      .fetchBonusesAvailable(FetchBonusTypesAvailableRequest)
      .then((results: FetchBonusTypesAvailableResponse) => {
        if (!componentLifeCycle.unmounted) {
          setState({ ...InitialState, data: results })
        }
      })
      .catch((error: string) => {
        if (!componentLifeCycle.unmounted) {
          setState({ ...InitialState, error })
        }
      })
  }

  return {
    state,
    bonuses: state.data?.items || [],
    hasCompatibles: state.data?.hasCompatibles,
    isInitialState,
    fetchBonusesAvailable,
  }
}
